import { Card } from '@/components/shared/card/Card';
import { constructNameEN } from '@/employee/employee-name-helper';
import { EmployeeAvatar } from '@/pages/home/clockIn/EmployeeAvatar';
import { useStaffById } from '@/services/staff/useStaffById';
import { FunctionComponent } from 'react';

interface ViewRosterEmployeeProps {
  identityId: string;
  startTime: string;
  endTime: string;
}

const ViewRosterEmployee: FunctionComponent<ViewRosterEmployeeProps> = ({ identityId, startTime, endTime }) => {
  const employee = useStaffById(identityId);

  return (
    <Card className="flex items-center gap-3 py-4 px-8">
      <EmployeeAvatar
        employee={{
          firstName: employee?.firstName ?? '',
          lastName: employee?.lastName ?? '',
          avatarUrl: employee?.avatarUrl ?? undefined,
          id: employee?.identityId
        }}
        size={32}
      />

      <span className="flex-1 text-sm text-gray-900">
        {constructNameEN(employee?.firstName ?? '', employee?.lastName ?? '')}
      </span>
      <span className="text-sm font-medium text-gray-500">
        {startTime} - {endTime}
      </span>
    </Card>
  );
};

export default ViewRosterEmployee;
